import { faCheckCircle, faEdit } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IKImage } from "imagekitio-react";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const careerGoals = ["Certifications", "Practical Learning", "Placements"];
const pointers = {
  "LearnTube Pro": [
    {
      is_available: true,
      point_name: "Unlimited Free Certificates (Skill & Micro-skill)",
    },
    { is_available: true, point_name: "Unlimited Access to all 250+ Courses" },
    {
      is_available: true,
      point_name: " Verified Certification with Lifetime Validity",
    },
    { is_available: true, point_name: "Lifetime Access to Completed Courses" },
  ],
  LearnTubeX: [
    {
      is_available: true,
      point_name: "Unlimited Weekly Workshops & Doubt Solving",
    },
    { is_available: true, point_name: "Live Projects with Guidance" },
    { is_available: true, point_name: "Placement Training" },
    {
      is_available: true,
      point_name: "Unlimited Free Certificates (Skill & Micro-skill)",
    },
  ],
  "LearnTube Max": [
    { is_available: true, point_name: "100% Placement Support" },
    {
      is_available: true,
      point_name: "LinkedIn Endorsement & Recommendation Letter",
    },
    { is_available: true, point_name: "Unlimited Live Workshops & Projects" },
    {
      is_available: true,
      point_name: "Unlimited Free Certificates (Skill & Micro-skill)",
    },
  ],
  Downgrade: [
    { is_available: true, point_name: "Access to All Courses" },
    { is_available: false, point_name: " Get Unlimited Certifications" },
    { is_available: false, point_name: "Work on Practical Projects" },
    { is_available: false, point_name: "CV and LinkedIn review" },
    { is_available: false, point_name: "100% placement support" },
  ],
};
const PricingHeader = ({
  activePlan,
  isCareerGoal,
  cardDatas,
  setIsCareerModalEnabled,
  setSeeDetails,
  razorpayHandler,
}) => {
  const user_role = useSelector((store) => store?.userSubscription?.user_role);
  const userPlan = useSelector((store) => store?.userSubscription);
  const [spinner, setSpinner] = useState(false);
  const isBlocked = useSelector(
    (store) => store?.userActivity?.user_trial_blocked,
  );
  const validity = Math.floor(
    (userPlan?.current_subscription_expires_at -
      userPlan?.current_subscription_started_at) /
      (1000 * 60 * 60 * 24 * 30),
  );

  function openRazorPay() {
    setSpinner(true);
    if (activePlan?.plan_name === "LearnTube Pro") {
      if (validity < 2) {
        razorpayHandler(activePlan?.plan_products?.[0]?.products_id, () =>
          setSpinner(false),
        );
      } else if (validity < 4) {
        razorpayHandler(activePlan?.plan_products?.[1]?.products_id, () =>
          setSpinner(false),
        );
      } else {
        razorpayHandler(activePlan?.plan_products?.[2]?.products_id, () =>
          setSpinner(false),
        );
      }
    } else if (activePlan?.plan_name === "LearnTubeX") {
      razorpayHandler(activePlan?.plan_products?.[0]?.products_id, () =>
        setSpinner(false),
      );
    } else if (activePlan?.plan_name === "LearnTube Max") {
      if (validity < 2) {
        razorpayHandler(18, () => setSpinner(false));
      } else {
        razorpayHandler(activePlan?.plan_products?.[0]?.products_id, () =>
          setSpinner(false),
        );
      }
    }
  }

  const customSpinner = () => {
    return (
      <div
        className={`h-8 w-8 rounded-full border-4 border-[${activePlan?.plan_color_secondary}] animate-spin border-t-transparent`}
      ></div>
    );
  };
  //console.log('activePlan' , activePlan , isCareerGoal)

  return isCareerGoal?.is_show ? (
    <div
      className="flex w-full flex-col items-start justify-center px-4 py-2 md:mt-4 md:w-7/12 md:items-center md:rounded-lg md:py-4"
      style={{
        background: `linear-gradient(418deg, ${activePlan?.plan_color_primary} 16.15%, ${activePlan?.plan_color_secondary} 86.12%)`,
      }}
    >
      <div className="flex flex-row items-center justify-center text-2xl text-white md:text-[44px]">
        <img
          className="h-7 md:h-[53px]"
          height={window.innerWidth > 758 ? "53px" : "28px"}
          src={activePlan?.plan_image}
          alt="active plan image"
        ></img>
        <div className="ml-4 font-bold ">{activePlan?.plan_name}</div>
      </div>
      <div className="flex flex-row items-center justify-center text-base font-medium text-white md:text-[20px]">
        <div className="whitespace-nowrap">Recommended Plan For</div>
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="ml-2 text-green-400"
        ></FontAwesomeIcon>
        <div className="ml-1 whitespace-nowrap">
          {isCareerGoal?.selected_goal?.goal_name}
        </div>
        <FontAwesomeIcon
          icon={faEdit}
          className="ml-2 cursor-pointer"
          onClick={(e) => setIsCareerModalEnabled(true)}
        />
      </div>
    </div>
  ) : (
    <div
      className="flex w-full flex-col items-start justify-center px-4 py-2 md:mt-4 md:w-7/12 md:rounded-lg md:py-4"
      style={{
        background: `linear-gradient(418deg, ${activePlan?.plan_color_primary} 16.15%, ${activePlan?.plan_color_secondary} 86.12%)`,
      }}
    >
      <div className="text-[16px] font-medium text-white md:text-[18px]">
        Current Plan
      </div>
      <div className="flex flex-row items-center justify-center text-[24px] text-white md:text-[44px]">
        <img
          className="h-7 md:h-10"
          height={window.innerWidth > 758 ? "40px" : "28px"}
          src={activePlan?.plan_image}
          alt="active plan image"
        ></img>
        <div className="ml-4 font-bold ">
          {user_role === 7
            ? "LearnTube Max Trial"
            : activePlan?.plan_name === "Downgrade"
            ? "Free Plan"
            : activePlan?.plan_name}
        </div>
      </div>
      <div className="w-full">
        {pointers[activePlan?.plan_name]?.map((point, idx) => (
          <div className="text-md mt-1 flex w-full items-center text-white md:mt-2 md:text-[18px]">
            {point?.is_available ? (
              <FontAwesomeIcon icon={faCheckCircle} className="h-4 w-4" />
            ) : (
              <img
                urlEndpoint="https://img.learntube.ai/public-assets/"
                src="https://img.learntube.ai/public-assets/PRICING/cross_18.svg?updatedAt=1681540173194"
                transformation={[
                  {
                    height: "150",
                    width: "150",
                  },
                ]}
                className="h-4 w-4"
              />
            )}
            <div className="ml-2 md:text-[16px]">{point?.point_name}</div>
          </div>
        ))}
      </div>
      {user_role !== 1 && (
        <div className="mt-2 flex flex-row items-center justify-center  text-sm text-white">
          <button
            className="cursor-pointer rounded-lg bg-white px-4 py-2 text-black md:mt-2"
            onClick={(e) => openRazorPay(e)}
          >
            {spinner ? customSpinner() : "Renew Subscription"}
          </button>
          <div
            className="ml-2 cursor-pointer underline"
            onClick={(e) => setSeeDetails(true)}
          >
            View Plan Details
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingHeader;
